import React from 'react';
import "../styles/legend.css";

function Legend(props) {

    return (
        <>
        <h1 style={{marginBottom: "16px"}}>Legend</h1>
        <h5 className="text"><strong>Descripton: </strong><br></br>{props.desc}</h5>
        <h5 className="text"><strong>Best Case: </strong><br></br>{props.bestCase}</h5>
        <h5 className="text"><strong>Worst Case: </strong><br></br>{props.worstCase}</h5>
        <h5 className="text"><strong>Colors: </strong><br></br>{props.colors}</h5>
        </>
    )
}

export default Legend;